import { z } from "zod";
import i18n from "./i18n/i18n";

export const AFFILIATION_MAX_CHARS = 200;

export const withAffiliationMax = (schema: z.ZodString) =>
  schema.refine(
    (value) => value.length <= AFFILIATION_MAX_CHARS,
    () => ({ message: i18n.t("autores.afiliacion_error") }),
  );
